import Base from "components/ConfiguratorApp/Base";
import Quotes from "pages/Quotes";
import React from "react";
const CustomerQuotesPage = () => {
  return (
    <Base>
      <Quotes />
    </Base>
  );
};
export default CustomerQuotesPage;
